<template>
  <div>
    <div class="clearfix">
      <Form
        @submit.native.prevent
        :model="formData"
        inline
        label-position="left"
        class="mytable-titleBox fl"
      >
        <!--        <FormItem label="用户昵称:" class="fl mytable-title" :label-width="72">-->
        <!--          <Input v-model="formData.username" placeholder="请输入用户昵称"></Input>-->
        <!--        </FormItem>-->
        <FormItem label="用户手机号:" :label-width="90">
          <Input v-model="formData.phone" placeholder="请输入用户手机号"></Input>
        </FormItem>
        <FormItem class="ml20" label="全部付款费用:" :label-width="100">
          <Input
            @on-change="clearOther(1)"
            v-model="formData.all_money_start"
            class="money_input"
            type="number"
          />--
          <Input
            @on-change="clearOther(1)"
            v-model="formData.all_money_end"
            class="money_input"
            type="number"
          />
        </FormItem>
        <FormItem class="ml20" label="已消耗费用:" :label-width="90">
          <Input
            @on-change="clearOther(2)"
            v-model="formData.real_money_start"
            class="money_input"
            type="number"
          />--
          <Input
            @on-change="clearOther(2)"
            v-model="formData.real_money_end"
            class="money_input"
            type="number"
          />
        </FormItem>
        <div class="clearfix checkReset" style="display:inline-block;">
          <Button type="primary" class="fl" @click="handleQuery">查询</Button>
          <Button class="fl" @click="handleReset">重置</Button>
        </div>
        <div class="line"></div>
        <RadioGroup
          v-model.trim="formData.vip_status"
          type="button"
          class="fl mr20"
          @on-change="handleRefundchange"
        >
          <Radio :label="null">全部</Radio>
          <Radio :label="0">球场萌新</Radio>
          <Radio :label="1">白银会员</Radio>
          <Radio :label="2">黄金会员</Radio>
          <Radio :label="3">铂金会员</Radio>
          <Radio :label="4">钻石会员</Radio>
          <Radio :label="5">王者会员</Radio>
        </RadioGroup>
      </Form>
    </div>

    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      activeNum: 1,
      formData: {
        vip_status:null,
        total_money: 1,
        total_real: 0,
        real_money_start: "",
        real_money_end: "",
        all_money_start: "",
        all_money_end: ""
      },
      formData1: {
        vip_status:null,
        total_money: 1,
        total_real: 0,
        real_money_start: "",
        real_money_end: "",
        all_money_start: "",
        all_money_end: ""
      },
      tableData: [],
      columns: [
        {
          title: "序号",
          key: "",
          render: (h, params) => {
            if (params.row.phone) {
              return h(
                "span",
                params.index + (this.page_num - 1) * this.page_size
              );
            }
          }
        },
        {
          title: "用户昵称",
          key: "username",
          render: (h, params) => {
            if (params.row.phone) {
              return h("span", params.row.username);
            } else {
              return h("span", "无手机号用户");
            }
          }
        },
        {
          title: "用户头像",
          key: "poster",
          render: (h, params) => {
            if (params.row.phone) {
              return h("img", {
                class: {
                  table_pic: true
                },
                domProps: {
                  src: params.row.poster
                }
              });
            }
          }
        },
          {
          title: "会员等级",
          key: "vip_level"
        },
        {
          title: "用户手机号",
          key: "phone",
          render:(h,params)=>{
            var phone =params.row.phone?params.row.phone.substr(0, 3) + "****" +params.row.phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "全部付款费用",
          key: "total_money",
          renderHeader: (h, params) => {
            if (this.formData.total_money == 0) {
              return h("div", [
                h("span", "全部付款费用"),
                h("img", {
                  attrs: {
                    src: require("../../assets/images/icon_down.png"),
                    title: "img"
                  },
                  on: {
                    click: this.handleChangeTotal.bind(this, 1)
                  },
                  class: {
                    btn: true
                  }
                })
              ]);
            } else {
              return h("div", [
                h("span", "全部付款费用"),
                h("img", {
                  attrs: {
                    src: require("../../assets/images/icon_down_active.png"),
                    title: "img"
                  },
                  on: {
                    click: this.handleChangeTotal.bind(this, 2)
                  },
                  class: {
                    btn: true
                  }
                })
              ]);
            }
          }
        },
        {
          title: "已退款费用",
          key: "total_refund"
        },
        {
          title: "已消耗费用",
          key: "total_real",
          renderHeader: (h, params) => {
            if (this.formData.total_real == 0) {
              return h("div", [
                h("span", "已消耗费用"),
                h("img", {
                  attrs: {
                    src: require("../../assets/images/icon_down.png"),
                    title: "img"
                  },
                  on: {
                    click: this.handleChangeReal.bind(this, 1)
                  },
                  class: {
                    btn: true
                  }
                })
              ]);
            } else {
              return h("div", [
                h("span", "已消耗费用"),
                h("img", {
                  attrs: {
                    src: require("../../assets/images/icon_down_active.png"),
                    title: "img"
                  },
                  on: {
                    click: this.handleChangeReal.bind(this, 2)
                  },
                  class: {
                    btn: true
                  }
                })
              ]);
            }
          }
        }
        // {
        //   title: '订单数',
        //   key: 'order_count'
        // },
      ]
    };
  },
  mounted() {
    this.handleQuery();
  },
  methods: {
    //会员切换
    handleRefundchange() {
      this.handleQuery();
    },
    clearOther(num) {
      if (num == 1) {
        //全部费用
        this.formData.real_money_start = "";
        this.formData.real_money_end = "";
        this.activeNum = 1;
      } else {
        this.formData.all_money_start = "";
        this.formData.all_money_end = "";
        this.activeNum = 2;
      }
      // this.formData.phone = ''
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.handleQuery();
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      if (this.activeNum == 1) {
        this.formData.total_real = 0;
        this.formData.total_money = 1;
      } else if (this.activeNum == 2) {
        this.formData.total_real = 1;
        this.formData.total_money = 0;
      }
      this.$api
        .moneyRanking({
          ...this.formData,
          page_num: this.page_num,
          page_size: this.page_size
        })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total_row;
          } else {
            this.$Message.error(res.msg);
          }
          this.tableLoading = false;
        });
    },
    handleChangeReal(num) {
      if (num == 1) {
        this.formData.total_real = num;
        this.formData.total_money = 0;
        this.formData.all_money_start = "";
        this.formData.all_money_end = "";
        this.activeNum = "";
        this.handleQuery();
      }
    },
    handleChangeTotal(num) {
      if (num == 1) {
        this.formData.total_money = num;
        this.formData.total_real = 0;
        this.formData.real_money_start = "";
        this.formData.real_money_end = "";
        this.activeNum = "";
        this.handleQuery();
      }
    }
  }
};
</script>

<style scoped lang="less">
.mytable-titleBox{
  width: 100%;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
.money_input {
  width: 80px;
}
/deep/ .ivu-form-item {
  margin-bottom: 12px;
}
.ml40 {
  margin-left: 40px;
}
</style>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.line{
  margin: 24px 0;
}
</style>
